// import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Component, ViewChild, AfterViewInit, NgModule, Inject, OnInit, ChangeDetectorRef} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import {merge, Observable, of as observableOf, Subject} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { BrowserModule } from '@angular/platform-browser';
import { HttpService } from '../../http.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar} from '@angular/material/snack-bar';
import { AuthenticationService } from '../../_services';
import { EntradaService } from '../../_services';
import { FulfillmentService } from '../../_services';
import { first } from 'rxjs/operators';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import { TranslateService } from '@ngx-translate/core';
import { calcularDisponibilidad } from '../../_helpers';
import { environment } from 'src/environments/environment';

interface FulfillmentStatus {
  value: string;
  viewValue: string;
}
interface EnviotStatus {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'fulfillments-tab-1',
  templateUrl: './fulfillments-tab-1.html',
  styleUrls: ['./fulfillments.component.scss']

})
export class FulfillmentsTab1 implements AfterViewInit {

  displayedColumns: string[] = [
                                  'canal',
                                  'shopify_name',
                                  'cliente',
                                  'fulfillment_status',
                                  'status_envio',
                                  'fecha_estado',
                                  'tracking_number',
                                  'cancelar_orden',
                                ];
  entradaDatabase: EntradaDatabase | null;
  data: EntradaIssue[] = [];

  ff_status: FormControl =  new FormControl('', []);
  env_status: FormControl =  new FormControl('', []);

  fulfillment_status: FulfillmentStatus[] = [
    {value: 'unfulfilled_bo', viewValue: 'Backorders'},
    {value: 'cancelado', viewValue: 'Cancelado'},
    {value: 'fulfilled', viewValue: 'Fulfilled'},
    {value: 'pausado', viewValue: 'Pausado'},
    {value: 'unfulfilled', viewValue: 'Unfulfilled'},
  ];

  envio_status: EnviotStatus[] = [
    {value: 'guia_creada', viewValue: 'Guía creada'},
    {value: 'guia_transito', viewValue: 'En tránsito'},
    {value: 'entregada', viewValue: 'Entregada'},
    {value: 'demorada', viewValue: 'Demorada'},
  ];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  guiaForm: FormGroup;
  keywords = "";
  hay_datos = true;
  es_nuevo = true;
  onboarding_complete = true;
  usuario: any;
  titulo_diff = false;
  datos_iniciales = true;
  orders_atrasadas = false;
  orders_pausadas = false;
  cantidad_ordenes: number;
  cantidad_pausadas: number;
  getOrders = false;
  ordenPausada = false;
  spinner = false;
  on_proces = false;
  current_user: any

  constructor(
      private formBuilder: FormBuilder,
      private _httpClient: HttpClient,
      public dialog: MatDialog,
      private fulfillmentService: FulfillmentService,
      private authenticationService: AuthenticationService,
      private snackBar: MatSnackBar,
      private router: Router,
      private translate : TranslateService ,
  ) {
    translate.setDefaultLang(localStorage.getItem('idioma'));

  }

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;


  ngOnInit() {
    this.asignarDatos();
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue

  }

  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);
  }
  ngAfterViewInit() {

    this.fulfillmentService.getOnboardingComplete()
    .pipe(first())
    .subscribe(
      data => {
        if(data["result"] == 200){
          this.onboarding_complete = data["onboarding_complete"];
          if(!this.onboarding_complete){
            const mensaje_bienvenida = this.dialog.open(DialogGuiaFF4 ,{width:'550px', height: 'auto', data: {}});
            mensaje_bienvenida.afterClosed().subscribe(result => {
              this.hacerTabla(this.keywords);
            });
          }
        }
      },
      error => {
    });

    this.entradaDatabase = new EntradaDatabase(this._httpClient);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    this.hacerTabla(this.keywords);

  }

  setClasses() {


    let myClasses = {
     // retrasado: Date.parse(fecha_corte.toISOString()) > Date.parse(fecha_creado),
     // a_tiempo: Date.parse(fecha_corte.toISOString()) < Date.parse(fecha_creado),
    }

    return  myClasses
  }

  verOrders(){
    this.spinner = true;
    this.getOrders = true;
    this.hacerTabla(this.keywords);
  }

  verPausadas(){
    this.spinner = true;
    this.ordenPausada = true;
    this.hacerTabla(this.keywords);
  }

  quitarFiltro(){
    this.spinner = true;
    this.getOrders = false;
    this.ordenPausada = false;
    this.hacerTabla(this.keywords);
  }

  mostrarCard(){
    if(this.datos_iniciales){
      this.titulo_diff = true;
    }else{
      this.titulo_diff = false;
    }
    this.hay_datos = !this.hay_datos;
  }

  hacerTabla(filtros){
    merge(this.sort.sortChange, this.paginator.page, )
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.entradaDatabase!.getRepoIssues(
            this.sort.active, this.sort.direction, this.paginator.pageIndex, this.keywords, this.getOrders, this.ordenPausada, this.ff_status.value, this.env_status.value);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;

          if(data.items.length == 0) {
            this.hay_datos = false
            this.datos_iniciales = false
          }else{
            this.hay_datos = true
            this.datos_iniciales = true
          }

          if(data.orders_atrasadas.length > 0){
            this.orders_atrasadas = true;
            this.cantidad_ordenes = data.orders_atrasadas.length;
          }
          if(data.orders_pausadas.length > 0){
            this.orders_pausadas = true;
            this.cantidad_pausadas = data.orders_pausadas.length;
          }
          this.spinner = false;
          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }


  //  PARA DIALOGO GUIAS
  openDialog(entrada_token) {

    const dialogRef = this.dialog.open(DialogFf ,{width:'450px', height: 'auto', data: {token: entrada_token}});

    dialogRef.afterClosed().subscribe(result => {
      this.hacerTabla(this.keywords);
    });
  }

  applyFilterFulfillment(){
    this.hacerTabla(this.keywords);
  }
  applyFilterEnvio(){
    this.hacerTabla(this.keywords);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywords = filterValue.trim().toLowerCase();
    if(this.keywords === ""){
      this.keywords = "";
    }
    this.hacerTabla(this.keywords);
  }

  consultarOrden(order_id){
    this.fulfillmentService.consultarOrden(order_id)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          const dialogRef3 = this.dialog.open(DialogGuiaFF3 ,{width:'90vw', height: '90%',disableClose: false ,data: {params: data}});
          dialogRef3.afterClosed().subscribe(result => {
            if(result == "orden_updated"){
              this.snackBar.open("La orden se ha actualizado", "OK", {
                duration: 5000,
              });
            }else if(result == "orden_reanudada"){
              this.hacerTabla(this.keywords);
              this.snackBar.open("La orden se reanudo", "OK", {
                duration: 5000,
              });
            }
          });
        }
      },
      error => {
    });
  }

  cancelarOrden(order_id){
    this.on_proces = true;
    this.fulfillmentService.cancelarOrden(order_id)
    .pipe(first())
    .subscribe(
      data => {
        this.snackBar.open(data["result"], "OK", {
          duration: 5000,
        });
        this.on_proces = false;
        this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/fulfillments']);
        });
      },
      error => {
        this.on_proces = false;
    });
  }

  descancelarOrden(order_id){
    this.on_proces = true;
    this.fulfillmentService.desCancelarOrden(order_id)
    .pipe(first())
    .subscribe(
      data => {
        this.snackBar.open(data["result"], "OK", {
          duration: 5000,
        });
        this.on_proces = false;
        this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/fulfillments']);
        });
      },
      error => {
        this.on_proces = false;
    });
  }

  cambiar_estado(row){
    if(row.fulfillment_status == "fulfilled_by_seller"){
      this.cancelarOrden(row.id);
    }else if(row.fulfillment_status == "pausado"){
      this.pausarOrden(row.id);
    }else if(row.fulfillment_status == "unfulfilled"){
      this.descancelarOrden(row.id);
    }
  }

  pausarOrden(order_id){
    this.on_proces = true;
    this.fulfillmentService.pausarOrden(order_id)
    .pipe(first())
    .subscribe(
      data => {
        this.snackBar.open(data["result"], "OK", {
          duration: 5000,
        });
        this.on_proces = false;
        this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/fulfillments']);
        });
      },
      error => {
        this.on_proces = false;
    });
  }

}

export interface EntradabApi {
  items: EntradaIssue[];
  total_count: number;
  orders_atrasadas: [];
  orders_pausadas: [];
}

export interface EntradaIssue {
  created_at: string;
  number: string;
  state: string;
  title: string;
}

/** An example database that the data source uses to retrieve data for the table. */
export class EntradaDatabase {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(sort: string, order: string, page: number, filtro: string, orders_atrasadas: boolean, ordenes_pausadas: boolean, fulfillment_status: string, envio_status: string): Observable<EntradabApi> {

     const href = `${environment.apiUrl}/shopi_orders.json`;
    let requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}&starts_with=${filtro}&fulfillment_status=${fulfillment_status}&envio_status=${envio_status}`;
    if(orders_atrasadas){
      requestUrl = requestUrl + '&orders_atrasadas=${orders_atrasadas}'
    }
    if(ordenes_pausadas){
      requestUrl = requestUrl + '&ordenes_pausadas=${ordenes_pausadas}'
    }

    return this._httpClient.get<EntradabApi>(requestUrl);
  }
}

export interface EntradabApi2 {
  items: ItemsIssue[];
  total_count: number;
}

export interface ItemsIssue {
  id: number;
  seller_sku: string;
  title: string;
  available_quantity: number;
}

export class EntradaDatabaseItems {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(filtro: string): Observable<EntradabApi2> {
    const href = `${environment.apiUrl}/rmsfe/listar_items.json`;
    const requestUrl = `${href}?nombre_producto=${filtro}&min_quantity=0`;
    return this._httpClient.get<EntradabApi2>(requestUrl);
  }
  getListCli(filtro: string): Observable<EntradabApi2> {
    const href = `${environment.apiUrl}/rmsfe/listar_clientes_api.json`;
    const requestUrl = `${href}?nombre_cliente=${filtro}`;
    return this._httpClient.get<EntradabApi2>(requestUrl);
  }
}

export interface ProductosEntrada {
  item_id: number,
  sku: string;
  ean: string;
  producto: string;
  cantidad: number;
}

@Component({
  selector: 'fulfillments-tab-2',
  templateUrl: './fulfillments-tab-2.html',
  styleUrls: ['./fulfillments.component.scss']

})

export class FulfillmentsTab2 implements OnInit {

  constructor(public dialog: MatDialog,
  private snackBar: MatSnackBar,
  private _httpClient: HttpClient,
  private router: Router,
  private fulfillmentService: FulfillmentService,
  private authenticationService: AuthenticationService
  ) {

  }
  breakpoint: number;
  columna1: number;
  columna2: number;
  columna3: number;
  not_found = false;
  entrada_final: [];
  ya_existe: number;
  filterName:string;
  filterCantidad: string;
  entradaDatabase: EntradaDatabaseItems | null;
  isLoadingResults = true;
  isRateLimitReached = false;
  resultsLength = 0;
  keywords = "";
  // data: object;
  dataItems: ItemsIssue[] = [];
  status_form = "reset"
  spinner = false;
  tiene_guia = false;
  current_user: any;
  delayTimer: any;

  // MyArrayType = Array<{sku: string, producto: string, cantidad: number}>;
  entradaFinal:ProductosEntrada[] = [];
  displayedColumns = ['sku', 'ean', 'producto', 'cantidad', 'action'];
  datos_tabla: ProductosEntrada[] = []



  itemForm = new FormControl('', [
    Validators.required,
  ]);

  cantidadForm = new FormControl('', [
    Validators.required,
    Validators.min(1),
  ]);


  options:[
  ];
  filteredOptions: Observable<ItemsIssue[]>;
  ngAfterViewInit() {

    this.entradaDatabase = new EntradaDatabaseItems(this._httpClient);

    // If the user changes the sort order, reset back to the first page.
    // this.hacerAutcomplete();
  }

  ngOnInit() {
    this.asignarDatos();
    this.breakpoint = (window.innerWidth <= 599) ? 1 : 6;
    this.columna1 = (window.innerWidth <= 599) ? 1 : 3;
    this.columna2 = (window.innerWidth <= 599) ? 1 : 2;
    this.columna3 = (window.innerWidth <= 599) ? 1 : 1;
    this.entradaDatabase = new EntradaDatabaseItems(this._httpClient);
    // If the user changes the sort order, reset back to the first page.
    this.hacerAutcomplete(this.keywords);
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue

  }
  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);
  }

  applyFilter(event: Event) {
    clearTimeout(this.delayTimer);
    this.delayTimer = setTimeout(() => {
      const filterValue = (event.target as HTMLInputElement).value;
      this.keywords = filterValue.trim().toLowerCase();
      this.hacerAutcomplete(this.keywords);
    }, 500);
  }

  filterStates(s: any) {
    let stateName = s.seller_sku || s; // s can be a State or a string
    return this.dataItems.filter(state =>
      state.seller_sku.toLowerCase().indexOf(stateName.toLowerCase()) === 0);
  }

  hacerAutcomplete(filtros){
    merge()
    .pipe(
      startWith({}),
      switchMap(() => {
        this.isLoadingResults = true;
        return this.entradaDatabase!.getRepoIssues(filtros);
      }),
      map(data => {
        // Flip flag to show that loading has finished.
        this.isLoadingResults = false;
        this.isRateLimitReached = false;
        this.resultsLength = data.total_count;
        return data.items;
      }),
      catchError(() => {
        this.isLoadingResults = false;
        // Catch if the GitHub API has reached its rate limit. Return empty data.
        this.isRateLimitReached = true;
        return observableOf([]);
      })
    ).subscribe(data => this.dataItems = data);
  }

  displayFn(subject){
    let texto = "";
    let cantidad = 0;
    if(subject){
      if(subject.seller_sku){
        cantidad = calcularDisponibilidad(subject);
        texto = subject.seller_sku + " | Cantidad Disp." + cantidad
        return texto;
      }else if(subject.title){
        cantidad =  calcularDisponibilidad(subject);
        texto = subject.title + " | Cantidad Disp." + cantidad
        return texto;
      }
    }else{
      return undefined;
    }

  }

  disponible_venta(item){ 
    const available_stock = calcularDisponibilidad(item);
    return available_stock;
  }

  validarDatos(){
    this.status_form = "submitted"
    if(this.itemForm.invalid || this.cantidadForm.invalid){
      return;
    }
    var elItem = this.itemForm.value;
    if(!elItem){
      return;
    }
    let producto = elItem.title;
    let item_id = elItem.id;
    let el_seller_sku = elItem.seller_sku;
    let cantidad_maxima = calcularDisponibilidad(elItem)
    let ean = elItem.ean;
    if(!(typeof elItem === 'object' && elItem !== null)){
      this.snackBar.open("Debes seleccionar un producto de la lista", "OK", {
        duration: 5000,
      });
      return;
    }
    if(this.cantidadForm.value > cantidad_maxima){
      if(cantidad_maxima == 0 && elItem.acepta_bo){

      }else{
        this.filterCantidad = "";
        this.snackBar.open("No puedes agregar más de la cantidad disponible", "OK", {
          duration: 3500,
        });
        return;
      }
    }
    //this.status_form = "reset"
    this.filterName = null;
    this.filterCantidad = null;
    this.addItem(this.entradaFinal, el_seller_sku, this.cantidadForm.value, producto, item_id, ean);
    // this.entradaFinal.push({sku: this.itemForm.value, producto: producto, cantidad: this.cantidadForm.value});

    this.datos_tabla = this.entradaFinal;
    this.datos_tabla = this.datos_tabla.filter((value,key)=>{
      return value;
    });
  }

  addItem(arr, seller_sku, quantity, titulo, item_id, ean) {
    let { length } = arr;
    let id = length + 1;
    let found = arr.some(el => el.item_id === item_id);
    if (!found){
      arr.push({sku: seller_sku, producto: titulo, cantidad: quantity, item_id: item_id, ean: ean});
    }else{
      let index = arr.findIndex(x => x.item_id === item_id);
      arr[index].cantidad = arr[index].cantidad + quantity;
    }
    return arr;
  }

  onResize(event) {
    this.breakpoint = (event.target.innerWidth <= 599) ? 1 : 6;
    this.columna1 = (window.innerWidth <= 599) ? 1 : 3;
    this.columna2 = (window.innerWidth <= 599) ? 1 : 2;
    this.columna3 = (window.innerWidth <= 599) ? 1 : 1;
  }

  deleteRowData(row_obj){
    this.datos_tabla = this.datos_tabla.filter((value,key)=>{
      return value.sku != row_obj.sku;
    });
    this.entradaFinal = this.datos_tabla;
  }

  preguntarGuia(){
    const dialogRef = this.dialog.open(DialogGuiaFF6, {width:'450px', height: 'auto',disableClose: true});

    dialogRef.afterClosed().subscribe(result => {
      if (result == true){
        this.tiene_guia = true;
      }else{
        this.tiene_guia = false;
      }
      this.enviarEntrada();

    });
  }

  enviarEntrada(){
    if(this.datos_tabla.length > 0){
      const dialogRef2 = this.dialog.open(DialogGuiaFF2 ,{width:'450px', height: 'auto',disableClose: true ,data: {entrada_final: this.entradaFinal, tiene_guia: this.tiene_guia}});

      dialogRef2.afterClosed().subscribe(result => {
        if(result){
          this.spinner = true;
          this.consultarStatusOrden(result);
        }
        //
        // AQUI PONER UN SPINNER
        // AQUI CONSULTAR EN UN LOOP SI YA ESTA LISTA LA ORDEN
        // CONSULTAR LA ORDEN Y PASARLA A DIALOG 3

        // if(result != false){
        //   const dialogRef3 = this.dialog.open(DialogGuiaFF3 ,{width:'90vw', height: '90%',disableClose: true ,data: {params: result}});
        //   this.entradaFinal = [ ]
        //   this.datos_tabla = [ ]
        // }

        // limpiar formulario y entries
      });
    }else{
      this.snackBar.open("Primero debes agregar productos a la Orden", "OK", {
        duration: 3500,
      });
    }
  }

  consultarStatusOrden(order_id){
    this.fulfillmentService.consultarStatus(order_id)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          if(data.body["result"][0] == 200){
            this.consultarOrden(order_id);
          }else{
            setTimeout(() =>
            {
              this.consultarStatusOrden(order_id);
            },3000);
          }
        }
      },
      error => {
    });
  }

  consultarOrden(order_id){
    this.fulfillmentService.consultarOrden(order_id)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.spinner = false;
          const dialogRef3 = this.dialog.open(DialogGuiaFF3 ,{width:'90vw', height: '90%',disableClose: false ,data: {params: data}});
          this.entradaFinal = [ ]
          this.datos_tabla = [ ]
          dialogRef3.afterClosed().subscribe(result => {
            // this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
            //   this.router.navigate(['/']);
            // });
          });
        }
      },
      error => {
    });
  }


  /** Gets the total cost of all datos_tabla. */
  getTotalCost() {
    return this.datos_tabla.map(t => t.cantidad).reduce((acc, value) => acc + value, 0);
  }

}


@Component({
  selector: 'fulfillments-tab-3',
  templateUrl: './fulfillments-tab-3.html',
  styleUrls: ['./fulfillments.component.scss']

})
export class FulfillmentsTab3 implements AfterViewInit {


  displayedColumns: string[] = [
                                  'canal',
                                  'shopify_name',
                                  'shopify_created_at',
                                  'created_at',
                                  'fecha_de_salida',
                                  'cliente',
                                  'liberar_bo'
                                ];
  backorderDatabase: BackorderDatabase | null;
  data: BackorderIssue[] = [];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  guiaForm: FormGroup;
  spinner            = false;
  keywords = "";
  hay_datos = true;
  titulo_diff = false;
  datos_iniciales = true;
  seller_id                  = null;
  usuario                    : string;

  constructor(
      private _httpClient: HttpClient,
      private fulfillmentService: FulfillmentService,
      private snackBar: MatSnackBar,
      private router: Router,
      private authenticationService: AuthenticationService
  ) { }

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  ngAfterViewInit() {

    this.backorderDatabase = new BackorderDatabase(this._httpClient);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    this.hacerTablaBo(this.keywords);

  }

  ngOnInit() {

    this.authenticationService.currentUser.subscribe(x => this.usuario = x);
    if(this.usuario){
      this.seller_id = this.usuario['seller_id'];
    }
  }

  setClasses() {
    let myClasses = {
    }
    return  myClasses
  }

  mostrarCard(){
    if(this.datos_iniciales){
      this.titulo_diff = true;
    }else{
      this.titulo_diff = false;
    }
    this.hay_datos = !this.hay_datos;
  }

  hacerTablaBo(filtros){
    merge(this.sort.sortChange, this.paginator.page, )
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.backorderDatabase!.getRepoIssues(
            this.sort.active, this.sort.direction, this.paginator.pageIndex, filtros);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          if(data.items.length == 0) {
            this.hay_datos = false
            this.datos_iniciales = false
          }else{
            this.hay_datos = true
            this.datos_iniciales = true
          }

          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }

  surtirBO(item_id,item_detal_id){
    this.spinner = true
    this.fulfillmentService.consultarBO(item_id)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("consultar bo es");
        // console.log(data);
        if(data.status == 200){
          if(data.body["result"] == 200){
            this.surtirBackOrder(item_id,item_detal_id);
          }else{
            this.spinner = false;
            this.snackBar.open("No existe ninguna BackOrder que surtir por el momento.", "OK", {
              duration: 3500,
            });
          }
        }

      },
      error => {
    });
  }

  surtirBackOrder(item_id,item_detal_id){
    this.fulfillmentService.surtirBO(item_id,item_detal_id)
    .pipe(first())
    .subscribe(
      data => {
        console.log("surtirBO es");
        if(data["result"] == 200){
          this.consultarStatusBO(item_id);
        }
      },
      error => {
    });
  }

  consultarStatusBO(item_id){
    this.fulfillmentService.consultarStatusBO(item_id)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("surtirBO es");
        // console.log(data);
        if(data.status == 200){
          if(data.body["result"][0] == 200){
            this.spinner = false;
            this.snackBar.open(data.body["result"][1], "OK", {
              duration: 3500,
            });
            this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
              this.router.navigate(['/fulfillments']);
            });
          }else{
            setTimeout(() =>
            {
              this.consultarStatusBO(item_id);
            },3000);
          }
        }
      },
      error => {
    });
  }

  surtirTodoBO(){
    this.spinner = true
    this.fulfillmentService.consultarTodoBO(this.seller_id)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("consultar bo es");
        // console.log(data);
        if(data.status == 200){
          if(data.body["result"] == 200){
            this.surtirTodoBackOrder(this.seller_id);
          }else{
            this.spinner = false;
            this.snackBar.open("No existe ninguna BackOrder que surtir por el momento.", "OK", {
              duration: 3500,
            });
          }
        }

      },
      error => {
    });
  }

  surtirTodoBackOrder(seller_id){
    this.fulfillmentService.surtirTodoBO(seller_id)
    .pipe(first())
    .subscribe(
      data => {
        console.log("surtirBO es");
        if(data["result"] == 200){
          this.consultarStatusTodoBO(seller_id);
        }
      },
      error => {
    });
  }

  consultarStatusTodoBO(seller_id){
    this.fulfillmentService.consultarStatusTodoBO(seller_id)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("surtirBO es");
        // console.log(data);
        if(data.status == 200){
          if(data.body["result"][0] == 200){
            this.spinner = false;
            this.snackBar.open(data.body["result"][1], "OK", {
              duration: 3500,
            });
            this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
              this.router.navigate(['/fulfillments']);
            });
          }else{
            setTimeout(() =>
            {
              this.consultarStatusTodoBO(seller_id);
            },3000);
          }
        }
      },
      error => {
    });
  }


}

export interface BackorderApi {
  items: BackorderIssue[];
  total_count: number;
}

export interface BackorderIssue {
  created_at: string;
  number: string;
  state: string;
  title: string;
}

/** An example database that the data source uses to retrieve data for the table. */
export class BackorderDatabase {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(sort: string, order: string, page: number, filtro: string): Observable<BackorderApi> {
     const href = `${environment.apiUrl}/rmsfe/backorders.json`;
    // const href = 'http://localhost:3000/rmsfe/query_entradas.json';
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}&starts_with=${filtro}`;

    return this._httpClient.get<BackorderApi>(requestUrl);
  }
}






@Component({
  selector: 'dialog-ff',
  templateUrl: './dialog-ff.html',
})
export class DialogFf {

  guiaForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error: string;
  la_guia: string;
  mensaje_success = false;
  guiaFormGuia: FormControl;
  formPaqueteria: FormControl;
  paqueteriaFormGuia: FormControl;
  spinner = false;
  entrada_token: string;
  keywords = "";
  otra = false;
  paqueteria: string;

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogFf>,
    private entradaService: EntradaService,
    @Inject(MAT_DIALOG_DATA) public data: any
    ){
    if(this.data.token){
      this.entrada_token = this.data.token;
    }
  }

  ngOnInit(){
    this.guiaForm = this.formBuilder.group({
      guiaFormGuia: ['', Validators.required],
    });

    this.guiaFormGuia = new FormControl('', [
      Validators.required,
    ]);

    this.formPaqueteria = new FormControl('', [
      Validators.required,
    ]);

    this.paqueteriaFormGuia = new FormControl('', [Validators.required]);
  }

  seleccionar(){
    if(this.formPaqueteria.value == "otro"){
      this.otra = true;
    }else{
      this.otra = false;
    }
  }

  guardarGuia(){
    if (this.guiaFormGuia.invalid || this.formPaqueteria.invalid || (this.otra && this.paqueteriaFormGuia.invalid)){

      return;
    }
    this.loading = true;
    this.spinner = true;

    this.mensaje_success = true;
    this.loading = false;
    this.spinner = false;

    if(this.otra){
      this.paqueteria = this.paqueteriaFormGuia.value;
    }else{
      this.paqueteria = this.formPaqueteria.value;
    }
    this.entradaService.actualizarEntrada(this.entrada_token, this.guiaFormGuia.value, this.paqueteria)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.mensaje_success = true;
          this.loading = false;
          this.spinner = false;
        }else{
          this.error = data.body["message"];
          this.loading = false;
          this.spinner = false;
        }
      },
      error => {
        this.error = error;
        this.loading = false;
        this.spinner = false;
   });
  }

}


@Component({
  selector: 'dialog-ff-2',
  templateUrl: './dialog-ff-2.html',
})
export class DialogGuiaFF2 {

  guiaForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error: string;
  la_guia: string;
  mensaje_success = false;
  guiaFormGuia: FormControl;
  formPaqueteria: FormControl;
  paqueteriaFormGuia: FormControl;
  checkForm: FormControl;
  spinner = false;
  entrada_token: string;
  entrada_final: object;
  keywords = "";
  otra = false;
  paqueteria: string;
  usuario: string;
  checked = false;
  formNombre: FormControl;
  formCorreo: FormControl;
  formTelefono: FormControl;
  formCalle: FormControl;
  formNumExterior: FormControl;
  formNumInterior: FormControl;
  formColonia: FormControl;
  formCiudad: FormControl;
  formEstado: FormControl;
  formCodigoPostal: FormControl;
  formCanal: FormControl;
  formNumOrden: FormControl;
  formTipoEnvio: FormControl;
  formAsegurar: FormControl;
  formFile: FormControl;
  formValorDeclarado : FormControl;
  formMontoCobrar : FormControl;
  hubo_error = false;
  datos_envio: object;
  file_name: string;
  orden_valida = false;
  fileToUpload: File = null;
  data_url: object;
  btn_disabled = false;
  tiene_guia = false;
  fulfillment_id: any;
  dataItemsCli: ItemsIssue[] = [];
  keywordsCli = "";
  entradaDatabase: EntradaDatabaseItems | null;
  toppingList: string[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogGuiaFF2>,
    private fulfillmentService: FulfillmentService,
    private authenticationService: AuthenticationService,
    private router: Router,
    public dialog: MatDialog,
    private _httpClient: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: any,
    ){
    if(this.data.entrada_final){
      this.entrada_final = this.data.entrada_final;
      this.tiene_guia = this.data.tiene_guia;
    }

    this.authenticationService.currentUser.subscribe(x => this.usuario = x);
    if(this.usuario){
      this.fulfillment_id = this.usuario['fulfillment_id'];
      this.usuario = this.usuario['seller_id'];
    }
  }

  ngAfterViewInit() {
    this.entradaDatabase = new EntradaDatabaseItems(this._httpClient);
  }

  ngOnInit(){
    this.entradaDatabase = new EntradaDatabaseItems(this._httpClient);
    this.hacerAutcompleteCli(this.keywordsCli);

    this.guiaForm = this.formBuilder.group({
      guiaFormGuia: ['', Validators.required],
    });

    this.guiaFormGuia = new FormControl({value: '', disabled: false}, [
      Validators.required,
    ]);

    this.formPaqueteria = new FormControl({value: '', disabled: false}, [
      Validators.required,
    ]);

    this.paqueteriaFormGuia = new FormControl({value: '', disabled: false}, [Validators.required]);

    this.checkForm = new FormControl('', []);
    this.checkForm.setValue(false);

    this.formNombre = new FormControl('', [Validators.required]);
    this.formCorreo = new FormControl('', [ Validators.email]);
    this.formTelefono = new FormControl('', [Validators.required]);
    this.formCalle = new FormControl('', [Validators.required]);
    this.formNumExterior = new FormControl('', [Validators.required]);
    this.formNumInterior = new FormControl('', []);
    this.formColonia = new FormControl('', [Validators.required]);
    this.formCiudad = new FormControl('', [Validators.required]);
    this.formEstado = new FormControl('', [Validators.required]);
    this.formCodigoPostal = new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]);
    this.formCanal = new FormControl('', [Validators.required]);
    this.formNumOrden = new FormControl('', [Validators.required]);
    this.formPaqueteria = new FormControl('', [Validators.required]);
    this.formTipoEnvio = new FormControl('', [Validators.required]);
    this.formAsegurar = new FormControl('', []);
    this.formAsegurar.setValue(false);
    this.formFile = new FormControl('', );
    this.formValorDeclarado = new FormControl('', [Validators.required]);
    this.formMontoCobrar = new FormControl('', [Validators.required]);
  }

  seleccionar(){
    if(this.formPaqueteria.value == "otro"){
      this.otra = true;
    }else{
      this.otra = false;
    }
  }


  updateToppingList(){

    let tipo_envio = this.formTipoEnvio.value;
    switch (tipo_envio) {
      case 'CoD_next_day':
        this.toppingList = ['Mas económico'];
      break;
      case 'CoD_same_day':
        this.toppingList = ['Mas económico'];
      break;
      case 'mismo_dia':
        this.toppingList = ['Mas económico', '99m'];
      break;
      case 'dia_siguiente':
        if (this.tiene_guia){
          this.toppingList = ['Mas económico', 'Estafeta', 'FedEx', 'Internacional', 'will_call', 'Amazon','DHL', 'MercadoLibre','99m','otro', 'tiui'];
        }else{
          this.toppingList = ['Mas económico', 'Estafeta', 'FedEx', 'Internacional', '99m', 'tiui'];
        }

      break;
      case 'economico':
        if (this.tiene_guia){
          this.toppingList = ['Mas económico', 'AMPM','Estafeta', 'FedEx', 'Internacional', 'Paquetexpress', 'will_call', 'Amazon','DHL', 'MercadoLibre','99m','otro', 'tiui'];
        }else{
          this.toppingList = ['Mas económico', 'AMPM','Estafeta', 'FedEx', 'Internacional', 'Paquetexpress', '99m', 'tiui'];
        }
      break;

      default:
      break;
    }
  }

  reload(){
    if(this.hubo_error){
    }else{
      this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/']);
      });
    }
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
    let tipo_archivo = this.fileToUpload.name.match(/(.pdf)/);
    if (tipo_archivo != null){

      this.spinner = true;
      this.btn_disabled = true;
      this.formFile.disable();

      this.fulfillmentService.getUploadURl(this.fileToUpload.type)
      .pipe(first())
      .subscribe(
        data => {
          if(data.status == 200){
            this.subirAWS(data.body["data"], this.fileToUpload);
          }else{
          }
        },
        error => {
      });
    }else{
      this.snackBar.open("Debe seleccionar un archivo pdf", "OK", {
        duration: 3500,
      });
      this.formFile.setValue(null);
    }
  }

  subirAWS(response, fileToUpload){
    this.fulfillmentService.subirArchivo(response.url, fileToUpload)
    .pipe(first())
    .subscribe(
      data => {
        this.file_name = response.file_name;
        this.spinner = false;
        this.btn_disabled = false;
        this.formFile.enable();
        this.snackBar.open("La guía se cargó correctamente", "OK", {
          duration: 3500,
        });
      },
      error => {
        this.spinner = false;
        this.btn_disabled = false;
        this.formFile.enable();
        this.snackBar.open("Ocurrió un error al cargar la guía, intentelo de nuevo.", "OK", {
          duration: 3500,
        });
    });

  }

  guardarEntrada(){
    this.btn_disabled = true;
    if (this.tiene_guia == false){
      if(this.formNombre.invalid || this.formCorreo.invalid || this.formTelefono.invalid || this.formCalle.invalid
        || this.formNumExterior.invalid || this.formNumInterior.invalid || this.formColonia.invalid
        || this.formCiudad.invalid || this.formEstado.invalid || this.formCodigoPostal.invalid || this.formCanal.invalid
        || this.formNumOrden.invalid || this.formPaqueteria.invalid || this.formTipoEnvio.invalid
        || this.formFile.invalid || (this.formAsegurar.value && this.formValorDeclarado.invalid) || ((this.formTipoEnvio.value == 'CoD_next_day' || this.formTipoEnvio.value == 'CoD_same_day') && this.formMontoCobrar.invalid)){

        this.btn_disabled = false;
        return;
      }
    }else{

      if(this.formCanal.invalid || this.formNumOrden.invalid || this.formPaqueteria.invalid || this.formTipoEnvio.invalid
        || this.formFile.invalid || (this.formAsegurar.value && this.formValorDeclarado.invalid) || ( (this.formTipoEnvio.value == 'CoD_next_day' || this.formTipoEnvio.value == 'CoD_same_day') && this.formMontoCobrar.invalid)){

        this.btn_disabled = false;
        return;
      }

      if (this.file_name == null){
        this.btn_disabled = false;
        this.snackBar.open("Debe cargar el archivo de la guía", "OK", {
          duration: 3500,
        });
        return;
      }
    }
    let nombreCli = "";
    if((typeof this.formNombre.value === 'object')){
      nombreCli = this.formNombre.value.nombre;
    }else{
      nombreCli = this.formNombre.value;
    }
    this.datos_envio = {
                  Nombre: nombreCli,
                  Correo: this.formCorreo.value,
                  Telefono: this.formTelefono.value,
                  Calle: this.formCalle.value,
                  NumExterior: this.formNumExterior.value,
                  NumInterior: this.formNumInterior.value,
                  Colonia: this.formColonia.value,
                  Ciudad: this.formCiudad.value,
                  Estado: this.formEstado.value,
                  CodigoPostal: this.formCodigoPostal.value,
                  Canal: this.formCanal.value,
                  NumOrden: this.formNumOrden.value,
                  Paqueteria: this.formPaqueteria.value,
                  TipoEnvio: this.formTipoEnvio.value,
                  Asegurar: this.formAsegurar.value,
                  FileName: this.file_name,
                  ValorDeclarado: this.formValorDeclarado.value,
                  MontoPagar: this.formMontoCobrar.value
                }

    this.fulfillmentService.validarOrden(this.data.entrada_final, this.datos_envio, this.file_name)
    .pipe(first())
    .subscribe(
      data => {
        if(data["status"] == 200){
          this.mensaje_success = true;
          this.loading = true;
          this.spinner = true;
          this.hubo_error = false;
          // this.mensaje_success = true;
          this.loading = true;
          this.spinner = true;
          this.orden_valida = true;
          this.fulfillmentService.enviarOrden(this.data.entrada_final, this.datos_envio, this.file_name)
            .pipe(first())
            .subscribe(
              data => {
                if(data.status == 200){
                  this.mensaje_success = true;
                 // this.loading = false;
                 // this.spinner = false;

                  this.dialogRef.close(data["shopi_order_id"]);
                }else{
                  this.error = data["message"];
                  this.loading = false;
                  this.spinner = false;
                  this.hubo_error = true;
                }
              },
              error => {
                this.error = error;
                this.loading = false;
                this.spinner = false;
                this.hubo_error = true;
            });
        }else{
          this.snackBar.open("El Canal y numero de Orden ya existen.", "OK", {
            duration: 5000,
          });
        }
      },
      error => {
        this.orden_valida = false;
        this.error = error;
        this.loading = false;
        this.spinner = false;
        this.hubo_error = true;
    });
  }

  applyFilterCli(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywordsCli = filterValue.trim().toLowerCase();
    this.hacerAutcompleteCli(this.keywordsCli);
  }

  hacerAutcompleteCli(filtros){
    merge()
    .pipe(
      startWith({}),
      switchMap(() => {
        return this.entradaDatabase!.getListCli(filtros);
      }),
      map(data => {
        if(data.items.length == 0){
          this.reset_inputs_form();
        }
        return data.items;
      }),
      catchError(() => {
        return observableOf([]);
      })
    ).subscribe(data => this.dataItemsCli = data);
  }

  displayFnCli(subject){
    if(subject){
      return subject.nombre;
    }else{
      return undefined;
    }
  }

  onSelectCli(cliente){
    if(cliente){
      this.formCorreo.setValue(cliente.correo);
      this.formTelefono.setValue(cliente.telefono);
      this.formCalle.setValue(cliente.calle);
      this.formNumExterior.setValue(cliente.num_exterior);
      this.formNumInterior.setValue(cliente.num_interior);
      this.formColonia.setValue(cliente.colonia);
      this.formCiudad.setValue(cliente.ciudad);
      this.formEstado.setValue(cliente.estado);
      this.formCodigoPostal.setValue(cliente.codigo_postal);
    }
  }

  reset_inputs_form(){
    this.formCorreo.setValue('');
    this.formTelefono.setValue('');
    this.formCalle.setValue('');
    this.formNumExterior.setValue('');
    this.formNumInterior.setValue('');
    this.formColonia.setValue('');
    this.formCiudad.setValue('');
    this.formEstado.setValue('');
    this.formCodigoPostal.setValue('');
  }

}

export interface HistorialOrden {
  event_time: string;
  event_name: string;
  nota_cliente: string;
}

@Component({
  selector: 'dialog-ff-3',
  templateUrl: './dialog-ff-3.html',
  styleUrls: ['./fulfillments.component.scss'],
})
export class DialogGuiaFF3 {
  params : any;
  usuario: string;
  datos_tabla: ProductosEntrada[] = []
  displayedColumns = ['sku', 'ean', 'producto', 'cantidad'];
  order_id: any;
  spinner = false;
  datos_tabla_historial: HistorialOrden[] = []
  displayedColumnsOrden = ['event_time', 'event_name', 'nota_cliente'];

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogGuiaFF3>,
    private fulfillmentService: FulfillmentService,
    private authenticationService: AuthenticationService,
    private router: Router,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
    ){
    if(this.data.params){
      this.params = this.data.params.body;
      this.datos_tabla = this.params["items"];
      this.order_id = this.params["orden"]["id"]
      this.datos_tabla = this.datos_tabla.filter((value,key)=>{
        return value;
      });
      this.datos_tabla_historial = this.params["historial"];
    }

    this.authenticationService.currentUser.subscribe(x => this.usuario = x);
    if(this.usuario){
      this.usuario = this.usuario['seller_id'];
    }
  }

  ngOnInit(){
  }

  closeDialog() {
    this.dialogRef.close('Pizza!');
  }

  reload(){
    this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
        this.router.navigate(['../entradas', 'tab1']);
    });
  }

  openOrden(){
    this.fulfillmentService.consultarEditarOrden(this.order_id)
    .pipe(first())
    .subscribe(
      data => {
        if(data["result"] == 200){
          const dialogRef2 = this.dialog.open(DialogGuiaFF5 ,{width:'450px', height: 'auto',disableClose: true ,data: {entrada_final: this.params}});
          dialogRef2.afterClosed().subscribe(result => {
            if(result == "orden_updated"){
              this.dialogRef.close(result);
            }
          });
        }else{
          this.snackBar.open(data["result"], "OK", {
            duration: 5000,
          });
        }
      },
      error => {
    });
  }

  redirect_devoluciones(params){
    if(params.orden.fulfillment_status != "fulfilled"){
      this.snackBar.open("Error, la orden debe tener el estado fulfilled", "OK", {
        duration: 5000,
      });
    }else{
      this.router.navigate(['/devoluciones'], { queryParams: { order_id: this.order_id }});
      this.dialogRef.close();
    }
  }

  reaundarOrden(){
    this.spinner = true;
    this.fulfillmentService.setReaundarOrden(this.order_id)
    .pipe(first())
    .subscribe(
      data => {
        if(data["result"] == 200){
          this.dialogRef.close("orden_reanudada");
        }else{
          this.snackBar.open(data["result"], "OK", {
            duration: 5000,
          });
          this.spinner = false;
        }
      },
      error => {
    });
  }

}


@Component({
  selector: 'dialog-ff-4',
  templateUrl: './dialog-ff-4.html',
  styleUrls: ['./fulfillments.component.scss'],
})
export class DialogGuiaFF4 {
  params : any;
  usuario: string;
  datos_tabla: ProductosEntrada[] = []
  displayedColumns = ['sku', 'producto', 'cantidad'];
  formAsegurar: FormControl;
  user: any;

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogGuiaFF3>,
    private fulfillmentService: FulfillmentService,
    private authenticationService: AuthenticationService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
    ){

    this.authenticationService.currentUser.subscribe(x => this.user = x);
    if(this.user){
      this.usuario = this.user['seller_name'];
    }
  }

  ngOnInit(){
    this.formAsegurar = new FormControl('', []);
  }

  closeDialog() {
    this.dialogRef.close('Pizza!');
  }

  setOnboarding(){
    if(this.formAsegurar.value){
      this.user["onboarding_complete"] = false;
      this.fulfillmentService.setOnboardingComplete()
      .pipe(first())
      .subscribe(
        data => {
        },
        error => {
      });
    }
  }



}




@Component({
  selector: 'app-fulfillments',
  templateUrl: './fulfillments.component.html',
  styleUrls: ['./fulfillments.component.scss'],
})
export class FulfillmentsComponent implements OnInit {
  user: any;
  seller_id: any;
  deshabilitado = false;
  current_user: any
  constructor(
    public dialog: MatDialog,
    private authenticationService: AuthenticationService,

  ) { }

  ngOnInit() {
    this.authenticationService.currentUser.subscribe(x => this.user = x);
    if(this.user){
      if(this.user["seller_id"] == 3){
        this.deshabilitado = true;
      }
    }
    this.asignarDatos();
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue

  }
  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);
  }

  @ViewChild(FulfillmentsTab1, {static: false})
  private timerComponent: FulfillmentsTab1;

  @ViewChild(FulfillmentsTab3, {static: false})
  private boComponent: FulfillmentsTab3;
  
  @ViewChild('historialTab', {static: false})
  private historialComponent: any;




  result = {
            body:{
              orden: {asegurado: false,
                            calle: "asdfa",
                            canal: "asdfas",
                            ciudad: "asdfsas",
                            codigo_postal: "23423",
                            colonia: "asdfasd",
                            correo: "",
                            estado: "asdfasd",
                            customer: "asdfasda",
                            noexterior: "asdfa",
                            nointerior: "asdfas",
                            shopify_name: "asdfas",
                            carrier_name: "FedEx",
                            telefono: "242423",
                            tipo_envio: "economico"},
              items: [{cantidad: 1, item_id: 115032, nombre_producto: "Bomba De Freno Fiat Palio Adventure 2004 - 2009", sku: "SR6024MX", created_at: "", backorder: false}]
            }
          }


  openDialog(): void {
    // consultar la orden
    const dialogRef3 = this.dialog.open(DialogGuiaFF3 ,{width:'90vw', height: '90%',disableClose: false ,data: {params: this.result}});


  }


  refrescarTabla(index: number) {
    //alert('going to get fresh score from DB ' + index);
    if(index == 0){
      this.timerComponent.hacerTabla('');
    }
    // El índice 3 corresponde a la pestaña de Historial
    if(index == 3 && this.historialComponent){
      this.historialComponent.cargarHistorial();
    }
    if(index == 4){
      this.boComponent.hacerTablaBo('');
    }
  }


}






@Component({
  selector: 'dialog-ff-5',
  templateUrl: './dialog-ff-5.html',
})
export class DialogGuiaFF5 {

  guiaForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error: string;
  la_guia: string;
  mensaje_success = false;
  guiaFormGuia: FormControl;
  formPaqueteria: FormControl;
  paqueteriaFormGuia: FormControl;
  checkForm: FormControl;
  spinner = false;
  entrada_token: string;
  entrada_final: object;
  keywords = "";
  otra = false;
  paqueteria: string;
  usuario: string;
  checked: boolean;
  formNombre: FormControl;
  formCorreo: FormControl;
  formTelefono: FormControl;
  formCalle: FormControl;
  formNumExterior: FormControl;
  formNumInterior: FormControl;
  formColonia: FormControl;
  formCiudad: FormControl;
  formEstado: FormControl;
  formCodigoPostal: FormControl;
  formCanal: FormControl;
  formNumOrden: FormControl;
  formTipoEnvio: FormControl;
  formAsegurar: FormControl;
  formFile: FormControl;
  formValorDeclarado : FormControl;
  formMontoCobrar : FormControl;
  hubo_error = false;
  datos_envio: object;
  file_name: string;
  orden_valida = false;
  fileToUpload: File = null;
  data_url: object;
  btn_disabled = false;
  params: any;
  order_id: any;
  formSKU: FormControl;
  formCantidad: FormControl;
  fulfillment_id: any;
  toppingList: string[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogGuiaFF2>,
    private fulfillmentService: FulfillmentService,
    private authenticationService: AuthenticationService,
    private router: Router,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any,
    ){
    if(this.data.entrada_final){
      this.params = this.data.entrada_final;
      this.order_id = this.params["orden"]["id"]
      if(this.params["orden"]["asegurado"]){
        this.checked = true;
      }else{
        this.checked = false;
      }
    }

    this.authenticationService.currentUser.subscribe(x => this.usuario = x);
    if(this.usuario){
      this.fulfillment_id = this.usuario['fulfillment_id'];
      this.usuario = this.usuario['seller_id'];
    }
  }

  ngOnInit(){
    this.guiaForm = this.formBuilder.group({
      guiaFormGuia: ['', Validators.required],
    });

    this.guiaFormGuia = new FormControl({value: '', disabled: false}, [
      Validators.required,
    ]);

    this.formPaqueteria = new FormControl({value: '', disabled: false}, [
      Validators.required,
    ]);

    this.paqueteriaFormGuia = new FormControl({value: '', disabled: false}, [Validators.required]);

    this.checkForm = new FormControl('', []);
    this.checkForm.setValue(false);

    this.formNombre = new FormControl(this.params["orden"]["customer"], [Validators.required]);
    this.formCorreo = new FormControl(this.params["orden"]["correo"], [ Validators.email]);
    this.formTelefono = new FormControl(this.params["orden"]["telefono"], [Validators.required]);
    this.formCalle = new FormControl(this.params["orden"]["calle"], [Validators.required]);
    this.formNumExterior = new FormControl(this.params["orden"]["noexterior"], [Validators.required]);
    this.formNumInterior = new FormControl(this.params["orden"]["nointerior"], []);
    this.formColonia = new FormControl(this.params["orden"]["colonia"], [Validators.required]);
    this.formCiudad = new FormControl(this.params["orden"]["ciudad"], [Validators.required]);
    this.formEstado = new FormControl(this.params["orden"]["estado"], [Validators.required]);
    this.formCodigoPostal = new FormControl(this.params["orden"]["codigo_postal"], [Validators.required, Validators.minLength(5), Validators.maxLength(5)]);
    this.formCanal = new FormControl(this.params["orden"]["canal"], [Validators.required]);
    this.formPaqueteria = new FormControl(this.params["orden"]["carrier_name"], [Validators.required]);
    this.formTipoEnvio = new FormControl(this.params["orden"]["tipo_envio"], [Validators.required]);
    this.formAsegurar = new FormControl('', []);
    this.formAsegurar.setValue(false);
    this.formSKU = new FormControl('', [Validators.required]);
    this.formCantidad = new FormControl('', [Validators.required, Validators.min(1)]);
    this.formFile = new FormControl(this.params["orden"]["file_name"], );
    this.formValorDeclarado = new FormControl(this.params["orden"]["valor_declarado"], [Validators.required]);
    this.formMontoCobrar = new FormControl(this.params["orden"]["precio"], [Validators.required]);
    this.updateToppingList();
    this.cdr.detectChanges();
  }

  seleccionar(){
    if(this.formPaqueteria.value == "otro"){
      this.otra = true;
    }else{
      this.otra = false;
    }
  }

  updateToppingList(){
    let tipo_envio = this.formTipoEnvio.value;
    switch (tipo_envio) {
      case 'CoD_next_day':
        this.toppingList = ['Mas económico'];
      break;
      case 'CoD_same_day':
        this.toppingList = ['Mas económico'];
      break;
      case 'mismo_dia':
        this.toppingList = ['Mas económico', '99m'];
      break;
      case 'dia_siguiente':
        this.toppingList = ['Mas económico', 'Estafeta', 'FedEx', 'Internacional', 'will_call', 'Amazon','DHL', 'MercadoLibre','99m','otro', 'tiui'];
      break;
      case 'economico':
        this.toppingList = ['Mas económico', 'AMPM','Estafeta', 'FedEx', 'Internacional', 'Paquetexpress', 'will_call', 'Amazon','DHL', 'MercadoLibre','99m','otro', 'tiui'];
      break;

      default:
      break;
    }
  }

  reload(){
    if(this.hubo_error){
    }else{
      this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/']);
      });
    }
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);

    this.fulfillmentService.getUploadURl(this.fileToUpload.type)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.subirAWS(data.body["data"], this.fileToUpload);
        }else{
        }
      },
      error => {
    });
  }

  subirAWS(response, fileToUpload){
    this.file_name = response.file_name
    this.fulfillmentService.subirArchivo(response.url, fileToUpload)
    .pipe(first())
    .subscribe(
      data => {
      },
      error => {
    });

  }

  guardarEntrada(){
    this.btn_disabled = true;
    if(this.formNombre.invalid || this.formCorreo.invalid || this.formTelefono.invalid || this.formCalle.invalid
      || this.formNumExterior.invalid || this.formNumInterior.invalid || this.formColonia.invalid
      || this.formCiudad.invalid || this.formEstado.invalid || this.formCodigoPostal.invalid
      || this.formPaqueteria.invalid || this.formTipoEnvio.invalid
      || this.formFile.invalid || (this.formAsegurar.value && this.formValorDeclarado.invalid) || ((this.formTipoEnvio.value == 'CoD_next_day' || this.formTipoEnvio.value == 'CoD_same_day') && this.formMontoCobrar.invalid)){

      this.btn_disabled = false;
      return;
    }

    var el_asegurado = "0"
    var valor_declarado = 0
    if(this.formAsegurar.value){
      el_asegurado = "1"
      valor_declarado = this.formValorDeclarado.value
    }

    this.loading = true;
    this.spinner = true;
    this.datos_envio = {
                  customer: this.formNombre.value,
                  correo: this.formCorreo.value,
                  telefono: this.formTelefono.value,
                  calle: this.formCalle.value,
                  noexterior: this.formNumExterior.value,
                  nointerior: this.formNumInterior.value,
                  colonia: this.formColonia.value,
                  ciudad: this.formCiudad.value,
                  estado: this.formEstado.value,
                  codigo_postal: this.formCodigoPostal.value,
                  carrier_name: this.formPaqueteria.value,
                  tipo_envio: this.formTipoEnvio.value,
                  asegurado: el_asegurado,
                  file_name: this.file_name,
                  valor_declarado: valor_declarado,
                  precio: this.formMontoCobrar.value
                }

    this.fulfillmentService.actualizarOrden(this.order_id, this.datos_envio)
    .pipe(first())
    .subscribe(
      data => {
        this.loading = false;
        this.spinner = false;
        this.dialogRef.close("orden_updated");
      },
      error => {
        this.orden_valida = false;
        this.error = error;
        this.loading = false;
        this.spinner = false;
        this.hubo_error = true;
    });
  }

  agregarProducto(){
    this.btn_disabled = true;
    if(this.formCantidad.invalid || this.formSKU.invalid || this.formCantidad.value <= 0){
      this.btn_disabled = false;
      return;
    }
    this.loading = true;
    this.spinner = true;
    this.fulfillmentService.agregarProducto(this.order_id, this.formCantidad.value, this.formSKU.value)
    .pipe(first())
    .subscribe(
      data => {
        if(data["result"] == 200){
          this.dialogRef.close("orden_updated");
        }else{
          this.btn_disabled = false;
          this.loading = false;
          this.spinner = false;
          this.snackBar.open(data["result"], "OK", {
            duration: 5000,
          });
        }
      },
      error => {
        this.orden_valida = false;
        this.error = error;
        this.loading = false;
        this.spinner = false;
        this.hubo_error = true;
    });
  }

}


@Component({
  selector: 'dialog-ff-6',
  templateUrl: './dialog-ff-6.html',
})
export class DialogGuiaFF6 {}

//!EMPIEZA  BLOQUE PARA CREAR LA FUNCIONALIDAD DE SOLICITAR FULFILLMENT EXCEL
@Component({
  selector: 'fulfillments-tab-4',
  templateUrl: './fulfillments-tab-4.html',
  styleUrls: ['./fulfillments.component.scss']

})

export class FulfillmentsTab4 implements OnInit {

  isLinear                   = false;
  firstFormGroup             : FormGroup;
  progress                   = false;
  descargar                  = false;
  url_descargar              = "";
  formFile                   : FormControl;
  file_name                  : string;
  fileToUpload               : File = null;
  exito                      = false;
  enviado                    = true;
  spinner                    = false;
  uploading                  = false; // Nueva variable para mostrar estado de carga
  isExcelFile                : boolean;
  keys                       : string[];
  dataSheet                  = new Subject();
  boxes                      : any;
  show_error_table           = false;
  show_enviar_formato        = false;
  error_data                 = [];
  displayedColumns: string[] = ['no_fila_excel', 'mensaje'];
  productos_pausados         = false;
  productos_en_ceros         = false;
  show_descargar_plantilla   = false;
  lista_errores              = [];
  arreglo_hoja_uno           = [];
  arreglo_hoja_dos           = [];
  seller_skus                = [];
  usuario                    : string;
  fulfillment_id             = null;
  seller_id                  = null;
  excel_subido               = false; // Nueva variable para control de archivo subido
  file_name_original         = null;

  constructor(private _formBuilder: FormBuilder,
    private fulfillmentService: FulfillmentService,
    private snackBar: MatSnackBar,
    private router: Router,
    public dialog: MatDialog,
    private authenticationService: AuthenticationService
    ) {}

  ngOnInit() {
    // this.traer_boxes();
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.formFile = new FormControl('', Validators.required);
    this.authenticationService.currentUser.subscribe(x => this.usuario = x);
    if(this.usuario){
      this.fulfillment_id = this.usuario['fulfillment_id'];
      this.seller_id = this.usuario['seller_id'];
    }
  }

  generarPlantilla(){
    this.spinner = true;
    this.consultarStatusPlantilla();
  }

  habilitarBtnGenerarPlantilla(){
    this.descargar = false;
    this.show_descargar_plantilla = false;
    this.url_descargar = null;
    this.show_error_table = false;
    this.error_data = [];
    this.show_enviar_formato = false;
    this.formFile.setValue(null);
    this.formFile.enable();
  }


  consultarStatusPlantilla(){
    this.fulfillmentService.consultarInformeGenerarPlantilla()
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          if(data.body["result"][0] == 200){
            this.url_descargar = data.body["result"][1];
            this.show_descargar_plantilla = true;
            this.descargar = true;
            this.snackBar.open("La plantilla se generó correctamente", "OK", {
              duration: 3500,
            });
            this.spinner = false;
          }else{
            setTimeout(() =>
            {
              this.consultarStatusPlantilla();
            },3000);
          }
        }
      },
      error => {
    });
  }

  handleFileInput(files: FileList) {
    this.show_error_table = false;
    this.show_enviar_formato = false;
    this.error_data = [];
    this.excel_subido = false;
    
    this.fileToUpload = files.item(0);
    if (this.fileToUpload == null){
      return false;
    }
    
    // Primero subimos el archivo a S3
    this.uploading = true;
    this.fulfillmentService.getUploadURlXlsx(this.fileToUpload.type)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.subirExcelAWS(data.body["data"], this.fileToUpload);
        } else {
          this.uploading = false;
          this.snackBar.open("Error al obtener URL para la carga del archivo", "OK", {
            duration: 3500,
          });
        }
      },
      error => {
        this.uploading = false;
        this.snackBar.open("Error al intentar subir el archivo", "OK", {
          duration: 3500,
        });
      });
  }
  
  subirExcelAWS(response, fileToUpload) {
    this.fulfillmentService.subirArchivoXLS(response.url, fileToUpload)
    .pipe(first())
    .subscribe(
      data => {
        this.file_name = response.file_name;
        this.file_name_original = this.fileToUpload.name;
        this.uploading = false;
        this.excel_subido = true;
        this.snackBar.open("El archivo se cargó correctamente", "OK", {
          duration: 3500,
        });
        
        // Una vez subido el archivo, procedemos a validarlo
        this.spinner = true;
        this.validar_xlsx({target: {files: [fileToUpload]}});
      },
      error => {
        this.uploading = false;
        this.snackBar.open("Ocurrió un error al cargar el archivo, inténtelo de nuevo.", "OK", {
          duration: 3500,
        });
    });
  }


  // Asegura que cada fila tenga exactamente 15 elementos (columnas A-O)
  normalizeRow(row, numColumns = 15) {
    const normalizedRow = [...row]; // Copia el array original
    
    //se reemplazar cualquier valor undefined con cadena vacía
    for (let i = 0; i < normalizedRow.length; i++) {
      if (normalizedRow[i] === undefined || normalizedRow[i] === "undefined" || normalizedRow[i] === "NULL") {
        normalizedRow[i] = "";
      }
    }
    
    //si la fila tiene menos elementos que las columnas requeridas, rellena con valores vacíos
    while (normalizedRow.length < numColumns) {
      normalizedRow.push("");
    }
    
    return normalizedRow;
  }
  
  //normaliza un conjunto de filas para asegurar que cada una tenga exactamente el número de columnas especificado
  normalizeRows(rows, numColumns = 15) {
    return rows.map(row => this.normalizeRow(row, numColumns));
  }

  async validar_xlsx(evt){
    let hoja1,hoja2,header,header2,hoja3;
    const target: DataTransfer = <DataTransfer>(evt.target);
    this.isExcelFile = !!target.files[0].name.match(/(.xls|.xlsx)/);
    if (target.files.length > 1) {
      this.formFile.setValue(null);
    }
    if (this.isExcelFile) {
      this.spinner = true;
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        /* read workbook */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        const wsname2: string = wb.SheetNames[1];
        const ws2: XLSX.WorkSheet = wb.Sheets[wsname2];



        /* save data */
        hoja1 = XLSX.utils.sheet_to_json(ws, {header:1});
        hoja1.shift(); // Elimina primera fila (fil del encabezado)
        //normaliza las filas para asegurar que todas tengan 15 columnas
        hoja1 = this.normalizeRows(hoja1);

        hoja2 = XLSX.utils.sheet_to_json(ws2, {header:1});
        hoja2.shift(); // Elimina primera fila (fil del encabezado)

        hoja3 = XLSX.utils.sheet_to_json(ws2, {header:1});
        hoja3.shift(); // Elimina primera fila (fil del encabezado)

        //! VALIDACION INDIVUAL DE LA HOJA 1 DATOS DE ENVIO

        let x = 2;
        for(let row of hoja1){
          //asegúrese de que la fila tiene exactamente 15 columnas
          row = this.normalizeRow(row);
          
          if(row.length > 0){
            let errores = [];

            var primer_dato = "error en la fila "+ x;
            errores.push("ERRORES DE LA HOJA Datos de Envio."+"\n");
            errores.push(primer_dato);
            let nombre       = row[0]; //obligatorio
            let correo       = row[1]; //obligatorio
            let telefono     = row[2]; //obligatorio
            let calle        = row[3]; //obligatorio
            let num_ext      = row[4]; //obligatorio
            let num_int      = row[5];
            let colonia      = row[6]; //obligatorio
            let ciudad       = row[7]; //obligatorio
            let estado       = row[8]; //obligatorio
            let codigo_cp    = row[9]; //obligatorio
            let canal        = row[10]; //obligatorio
            let numero       = row[11]; //obligatorio
            let tipo_envio   = row[12]; //obligatorio
            let paqueteria   = row[13]; //obligatorio
            let pdf_guia     = row[14];

            if (!this.validar_obligatorio(nombre)){
              errores.push("\n" +"El Nombre es obligatorio");
            }

            if (!this.validar_obligatorio(num_int)){
              row[5] = ' ';
            }

            if (!this.validar_obligatorio(correo)){
                errores.push("\n" +"El correo es obligatorio");
            }

            if (!this.validar_obligatorio(telefono)){
              errores.push("\n" +"El teléfono es obligatorio");
            }else if(!this.es_numerico(telefono)){
              errores.push("\n" +"El teléfono debe ser un dato numérico");
            }

            if (!this.validar_obligatorio(calle)){
              errores.push("\n" +"La calle es obligatorio");
            }

            if (!this.validar_obligatorio(num_ext)){
              errores.push("\n" +"El número exterior es obligatorio");
            }

            if (!this.validar_obligatorio(colonia)){
              errores.push("\n" +"La colonia es obligatorio");
            }

            if (!this.validar_obligatorio(ciudad)){
              errores.push("\n" +"La ciudad es obligatorio");
            }

            if (!this.validar_obligatorio(estado)){
              errores.push("\n" +"El estado  es obligatorio");
            }

            if (!this.validar_obligatorio(codigo_cp)){
              errores.push("\n" +"El código postal es obligatorio");
            }else if(!this.es_numerico(codigo_cp)){
              errores.push("\n" +"El código postal debe ser un dato numérico");
            }

            if (!this.validar_obligatorio(canal)){       //string
              errores.push("\n" +"El canal es obligatorio");
            }

            if (!this.validar_obligatorio(numero)){  //string
              errores.push("\n" +"El numero de orden es obligatorio");
            }

            if(!this.validar_obligatorio(tipo_envio)) {
              errores.push("\n" +"El tipo de envío es obligatorio");
            }

            if(!this.validar_obligatorio(paqueteria)) {
              errores.push("\n" +"La paquetería es obligatoria");
            }

             // Debe ser dirección web y .png o .jpg
            if (!this.isValidUrl(pdf_guia)){
                errores.push("\n" +`El link del pdf:  ${pdf_guia}  no tiene un formato URL válido`);
            }else{
              //TODO:ahora la url puede ser sin la extension .pdf
              // Validar que la URL sea valida y comience con https://
              if (pdf_guia && !pdf_guia.toString().toLowerCase().startsWith('https://')){
                errores.push("\n" +`El link del pdf:  ${pdf_guia} debe comenzar con https://`);
              }
              
                /*if (!this.validar_extension_archivo(pdf_guia, [".pdf"])){
                    errores.push("\n" +`El link del pdf:  ${pdf_guia} debe tener la extensión .png o .jpg`);
                }*/
            }
            if (errores.length > 2){
              errores.push("\n"+"******************************"+"\n");
              this.lista_errores.push(errores);

            }
          }
          x++;
        }

        //! VALIDACION INDIVIDUAL DE LA HOJA DOS PRODUCTOS A ENVIAR
        let y = 2;
        for(let row of hoja2){
          if(row.length > 0){
            let errores_hoja_dos = [];

            var primer_dato = "error en la fila "+ y;
            errores_hoja_dos.push("\n"+"ERRORES DE LA HOJA Productos a enviar."+"\n");
            errores_hoja_dos.push(primer_dato);

            let canal             = row[0];
            let numero_orden      = row[1];
            let seller_sku        = row[2];
            let cantidad_producto = row[3];

            if (!this.validar_obligatorio(canal)){       //string
              errores_hoja_dos.push("\n" +"El canal es obligatorio");
            }

            if (!this.validar_obligatorio(numero_orden)){  //string
              errores_hoja_dos.push("\n" +"El numero de orden es obligatorio");
            }

            if (!this.validar_obligatorio(seller_sku)){
              errores_hoja_dos.push("\n" +"El seller SKU es obligatorio");
            }

            if (!this.validar_obligatorio(cantidad_producto)){
              errores_hoja_dos.push("\n" +"La cantidad de productos es obligatorio");
            }else if(!this.es_numerico(cantidad_producto)){
              errores_hoja_dos.push("\n" +"La cantidad de producto debe ser un dato numérico");
            }




            if (errores_hoja_dos.length > 2){
              errores_hoja_dos.push("\n"+"******************************"+"\n");
              this.lista_errores.push(errores_hoja_dos);

            }
          }
          y++;
        }

        //! VALIDACIÓN PARA DETECTAR ÓRDENES DUPLICADAS EN HOJA 1
        let ordenes_registradas = {};
        let ordenes_duplicadas = [];
        
        for(let row of hoja1){
          // Asegúrese de que la fila tiene exactamente 15 columnas
          row = this.normalizeRow(row);
          
          if(row.length > 0){
            let numero_orden = row[11];
            let canal = row[10];
            let nombre = row[0];
            
            if(this.validar_obligatorio(numero_orden)){
              let clave_orden = canal + "_" + numero_orden;
              
              if(ordenes_registradas[clave_orden]){
                // La orden ya existe, es duplicada
                ordenes_duplicadas.push({
                  numero: numero_orden,
                  canal: canal,
                  nombre_original: ordenes_registradas[clave_orden].nombre,
                  nombre_duplicado: nombre
                });
              } else {
                // Registrar la orden para detectar duplicados
                ordenes_registradas[clave_orden] = {
                  nombre: nombre
                };
              }
            }
          }
        }
        
        // Si hay órdenes duplicadas, generar mensaje de error
        if(ordenes_duplicadas.length > 0){
          let errores_duplicados = [];
          errores_duplicados.push("ERRORES DE ÓRDENES DUPLICADAS EN EL ARCHIVO."+"\n");
          
          for(let orden of ordenes_duplicadas){
            errores_duplicados.push("\n" + `Orden duplicada: Número ${orden.numero} del Canal ${orden.canal}`);
            errores_duplicados.push("\n" + `- Primera aparición para: ${orden.nombre_original}`);
            errores_duplicados.push("\n" + `- Aparición duplicada para: ${orden.nombre_duplicado}`);
          }
          
          errores_duplicados.push("\n"+"******************************"+"\n");
          this.lista_errores.push(errores_duplicados);
        }

        //! BLOQUE DE VALIDACION SI EL NUMERO DE ORDEN Y CANAL COINCIDEN ENTRE AMBAS HOJAS
        for(let row of hoja1){
          // Asegúrese de que la fila tiene exactamente 15 columnas
          row = this.normalizeRow(row);
          
          let bandera_existe = false;
          if(row.length > 0){
            let errores_hojas = [];


            errores_hojas.push("ERRORES VALIDANDO EXISTENCIA N° ORDEN Y CANAL EN AMBAS HOJAS."+"\n");

            let nombre       = row[0]; //obligatorio
            let canal        = row[10];
            let numero_orden = row[11];

            for(let row2 of hoja2){
              if(row2.length > 0){
                let canal_hoja_dos        = row2[0];
                let numero_orden_hoja_dos = row2[1];

                if(canal == canal_hoja_dos && numero_orden_hoja_dos == numero_orden){
                  bandera_existe =true;
                }
              }
            }

            if(!bandera_existe){
              var mensaje = 'NO SE ENCONTRARON COINCIDENCIAS DEL NÚMERO DE ORDEN Y CANAL DE LA PERSONA '+nombre;
              errores_hojas.push(mensaje);
            }else{
              bandera_existe = false;
            }

            if (errores_hojas.length > 1){
              errores_hojas.push("\n"+"******************************"+"\n");
              this.lista_errores.push(errores_hojas);

            }
          }

        }

        // ! TERMINA VALIDACION DE EXISTENCIA DE DATOS DE
        if (this.lista_errores.length > 0){
          this.enviado = false;
          this.spinner = false;
          this.formFile.setValue(null);
          
          // Verificar si hay errores de órdenes duplicadas para mostrar mensaje específico
          let mensaje = "Hay registros con errores en el formato de excel";
          for(let error of this.lista_errores) {
            if(error[0] && error[0].includes("ERRORES DE ÓRDENES DUPLICADAS")) {
              mensaje = "Se detectaron números de orden duplicados en el archivo";
              break;
            }
          }
          
          this.snackBar.open(mensaje, "OK", {
            duration: 3500,
          });
        }else{
          this.enviado             = true;
          this.show_enviar_formato = true;
          this.formFile.disable();
          this.spinner             = false;
          this.arreglo_hoja_dos    = hoja2;
          this.arreglo_hoja_uno    = hoja1;
          this.validar_existencia_sku(hoja3);
        }

      }

      reader.readAsBinaryString(target.files[0]);
    } else {
      this.formFile.setValue(null);
    }
  }

  descargar_errores(){
    const a = document.createElement("a");
    var blob = new Blob(this.lista_errores, {type: "text/plain;charset=utf-8"});
    const url = URL.createObjectURL(blob);
    a.href = url;
    a.download = "errores_layout.txt";
    a.click();
    URL.revokeObjectURL(url);
    this.reset_variables_envio_excel();
  }


  validar_obligatorio(value) {

    if(value == undefined){
        return false;
    }else{
        value = value.toString().replace(/\s+/g, '');
        if (value == ""){
            return false;
        }
    }
    return true;
  }

  isValidUrl(value) {
    if(value != undefined){
        value = value.toString().replace(/\s+/g, ''); // Eliminamos espacios
        if (value != ""){
            try {
                new URL(value);
            } catch (_) {
                return false;
            }
        }
    }
    return true;
  }

  validar_extension_archivo(value, extensiones) {
    let salida = false;
    if(value != undefined){
        value = value.toString().replace(/\s+/g, ''); // Eliminamos espacios
        if (value != ""){
            for (let extension of extensiones){
                let split_data = value.split(extension);
                if (split_data.length > 1){
                    salida = true;
                }
            }
        }else{
            salida = true;
        }
    }else{
        salida = true;
    }
    return salida;
  }

  es_numerico(value) {
    if (value != undefined){
        value = value.toString().replace(/\s+/g, '');
        var valoresAceptados = /^[0-9]*(\.?)[0-9]+$/;
        if(value.match(valoresAceptados)){
            return true;
        }else{
            return false;
        }
    }
    return true;
  }

  validar_dato(value, array_values) {
    if(value != undefined){
        value = value.toString().replace(/\s+/g, ''); // Eliminamos espacios
        if (value == ""){
            return true;
        }
        array_values = array_values.map(function(x) { // Convertimos elementos del arreglo a minúsculas
            return x.toString().toLowerCase().replace(/\s+/g, '');
        });
        let validation_result = array_values.includes(value.toLowerCase());
        if (!validation_result){
            return false;
        }
    }
    return true;
  }

  render_error_table(lista_errores){
    for (let errores of lista_errores){
      let x = 0;
      let mensaje = "";
      let no_fila_excel = errores[0];
      for (let error of errores){
        if (x > 0){
            if (x == 1){
              mensaje = `${error}`;
            }else{
              mensaje = `${mensaje} |-| ${error}`;
            }
        }
        x++;
      }
      let row = {no_fila_excel: no_fila_excel, mensaje: mensaje}
      this.error_data.push(row);
    }


    this.show_error_table = true;
  }
  enviarEdicionMasiva(){
    if (!this.excel_subido || !this.file_name) {
      this.snackBar.open("Error: El archivo no ha sido subido correctamente", "OK", {
        duration: 3500,
      });
      return;
    }
    
    this.enviado = true;
    this.spinner = true;
    
    //asegurar que todas las filas estén normalizadas, sin valores undefined
    const hoja_uno_normalizada = this.normalizeRows(this.arreglo_hoja_uno);
    
    let datos_envio = {
      seller_skus      : this.seller_skus,
      seller_id        : this.seller_id,
      arreglo_hoja_uno : hoja_uno_normalizada,
      arreglo_hoja_dos : this.arreglo_hoja_dos,
      excel_filename   : this.file_name , // Añadimos el nombre del archivo que ya subimos
      excel_filename_original   : this.file_name_original 
    }

    this.fulfillmentService.guardar_ordenes_masivas(datos_envio)
      .pipe(first())
      .subscribe(
        data => {
          if(data.result){

            this.reset_variables_envio_excel();
            this.consultarStatusGuardadoOrdenesMasivo();
            this.snackBar.open("GUARDANDO ORDENES", "OK", {
              duration: 3500,
            });

          }else{
            if(data.tiene_errores2){
              this.lista_errores = data.errors;
              this.spinner = false;

              this.snackBar.open(data.message, "OK", {
                duration: 3500,
              });
            }

            if (data.tiene_errores ){
              this.lista_errores = data.errores;
              this.spinner = false;

              this.snackBar.open("Hay seller SKU con stock insuficientes", "OK", {
                duration: 3500,
              });
            }
          }

        },
        error => {
          this.spinner = false;
      });
  }
  reset_variables_envio_excel(){
    this.show_enviar_formato = false;
    this.isExcelFile         = null;
    this.arreglo_hoja_uno    = [];
    this.arreglo_hoja_dos    = [];
    this.seller_skus         = [];
    this.enviado             = false;
    this.excel_subido        = false;
    this.file_name           = null;
    this.show_enviar_formato = false;
    this.formFile.setValue(null);
    this.formFile.enable();
    this.lista_errores       = [];
    this.file_name_original  = null;
  }
  consultarStatusGuardadoOrdenesMasivo(){
    this.fulfillmentService.consultarStatusGuardadoOrdenesMasivo()
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          if(data.body["result"] == 200){
            this.spinner = false;

            let tiene_errores = false;
            if(data.body["detalles"] != true){
              if(data.body["detalles"] != null){
                this.lista_errores = data.body["detalles"]["errores"];
                tiene_errores = data.body["detalles"]["tiene_errores"];
              }else{

              }

            }

            if(tiene_errores){
              this.snackBar.open("HAY ORDENES QUE NO SE PUDIERON GUARDAR", "ERROR", {
                duration: 4000,
                panelClass: ['red-snackbar']
              });
            }else{
              this.snackBar.open("ORDENES GUARDADAS CORRECTAMENTE", "OK", {
                duration: 4000,
              });
            }


          }else{
            setTimeout(() =>
            {
              this.consultarStatusGuardadoOrdenesMasivo();
            },3000);
          }
        }
      },
      error => {
    });
  }

  validar_existencia_sku(data){

    this.seller_skus = this.sumar_sku_repetidos(data);
    this.spinner = true;
    let datos_envio = {
      arreglo_hoja_dos:this.seller_skus,
      seller_id : this.seller_id
    }

    this.fulfillmentService.validar_existencia_sku_orden(datos_envio)
      .pipe(first())
      .subscribe(
        data => {
          if(data.result){
            this.spinner             = false;
            this.show_enviar_formato = true;

          }else{

            if (data.tiene_errores){
              this.lista_errores = data.errores;
              this.spinner = false;
              this.show_enviar_formato = false;
              this.formFile.setValue(null);
              this.formFile.enable();
              this.snackBar.open("Hay seller SKU con stock insuficientes", "OK", {
                duration: 3500,
              });
            }
          }

        },
        error => {
          this.spinner = false;
      });
  }
  sumar_sku_repetidos(skus){

    let array_sku_sin_duplicados = [];
    array_sku_sin_duplicados = skus.reduce((acumulador, valorActual) => {
      let elementoYaExiste = acumulador.find(elemento => elemento[2] === valorActual[2]);

      if (elementoYaExiste) {
        return acumulador.map((elemento) => {
          if (elemento[2] === valorActual[2]) {
               elemento[3]= parseInt(elemento[3]) + parseInt(valorActual[3]);
             return elemento;
          }

          return elemento;
        });
      }
      return [...acumulador, valorActual];
    }, []);

    return array_sku_sin_duplicados;
  }
}
export interface HistorialBatchApi {
  batches: any[];
  total_count: number;
}

export class HistorialBatchDatabase {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(sort: string, order: string, page: number): Observable<HistorialBatchApi> {
    const href = `${environment.apiUrl}/rmsfe/historial_ordenes_masivas`;
    const requestUrl = `${href}?sort=${sort}&order=${order}&page=${page + 1}`;
    return this._httpClient.get<HistorialBatchApi>(requestUrl);
  }
}

@Component({
  selector: 'fulfillments-tab-5',
  templateUrl: './fulfillments-tab-5.html',
  styleUrls: ['./fulfillments.component.scss']
})
export class FulfillmentsTab5 implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['created_at', 'archivo', 'usuario', 'total', 'exitosos', 'errores', 'acciones'];
  historialDatabase: HistorialBatchDatabase | null;
  batches: any[] = [];
  spinner = false;
  showErrorModal = false;
  errorDetails: any[] = [];
  selectedBatch: any = null;
  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  hay_datos = true;
  datos_iniciales = true;
  titulo_diff = false;

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  constructor(
    private fulfillmentService: FulfillmentService,
    private snackBar: MatSnackBar,
    private translate: TranslateService,
    private _httpClient: HttpClient,
    private cdr: ChangeDetectorRef
  ) {
    translate.setDefaultLang(localStorage.getItem('idioma'));
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.historialDatabase = new HistorialBatchDatabase(this._httpClient);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    this.cargarHistorial();
  }

  cargarHistorial() {
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          this.spinner = true;
          this.cdr.detectChanges();
          return this.historialDatabase!.getRepoIssues(
            this.sort.active,
            this.sort.direction,
            this.paginator.pageIndex
          );
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.spinner = false;
          this.resultsLength = data.total_count;

          if(data.batches.length == 0) {
            this.hay_datos = false
            this.datos_iniciales = false
          } else {
            this.hay_datos = true
            this.datos_iniciales = true
          }

          return data.batches;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          this.isRateLimitReached = true;
          this.spinner = false;
          this.snackBar.open("Error al cargar el historial", "OK", {
            duration: 3500,
          });
          return observableOf([]);
        })
      ).subscribe(data => this.batches = data);
  }

  descargarArchivo(batchId: number) {
    this.spinner = true;
    this.fulfillmentService.descargarExcelBatch(batchId)
      .pipe(first())
      .subscribe(
        data => {
          if (data && data.download_url) {
            window.open(data.download_url, '_blank');
          } else {
            this.snackBar.open("No se pudo generar la URL de descarga", "OK", {
              duration: 3500,
            });
          }
          this.spinner = false;
        },
        error => {
          this.spinner = false;
          this.snackBar.open("Error al descargar el archivo", "OK", {
            duration: 3500,
          });
        }
      );
  }

  verErrores(batchId: number) {
    this.spinner = true;
    this.selectedBatch = this.batches.find(b => b.id === batchId);
    this.errorDetails = [];
    this.showErrorModal = true;
    
    this.fulfillmentService.obtenerErroresBatch(batchId)
      .pipe(first())
      .subscribe(
        data => {
          if (data && data.errors) {
            this.errorDetails = data.errors;
            if (data.batch) {
              this.selectedBatch = data.batch;
            }
          }
          this.spinner = false;
        },
        error => {
          this.spinner = false;
          this.errorDetails = [{
            description: "Error al cargar los detalles de errores"
          }];
        }
      );
  }

  cerrarModal(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      this.showErrorModal = false;
    }
  }

  mostrarCard() {
    if(this.datos_iniciales) {
      this.titulo_diff = true;
    } else {
      this.titulo_diff = false;
    }
    this.hay_datos = !this.hay_datos;
  }
}